import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Character Generator Online
        </p>
      </header>
    </div>
  );
}

export default App;
